export enum USER_VIEW_TYPE {
  GRID = 'GRID',
  LIST = 'LIST',
}
